export default __webpack_public_path__ + "static/media/Small Grenade.240d34f3.PNG";